
class CapViewDeveloperDebugData {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_developer_debug_data'
}

function create(config) {
  return new CapViewDeveloperDebugData(config)
}

export default {
  key,
  create,
}
